import PictureShow from './PictureShow';

export default PictureShow;  


// WEBPACK FOOTER //
// ./src/components/PictureShow/index.js